import React from "react";
import "./dwechome.css";
import "./couselllingeducationloan.css";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/footer";
import InterestedSectionMain from "../../components/interested section/InterestedSectionMain";
const immigration_img = require("../../assets/immigration2.svg");
const immigration_img1 = require("../../assets/immigration1.svg");
const immigration_img2 = require("../../assets/immigration4.svg");
const immigration_img3 = require("../../assets/immigration3.svg");

function ImmigrationMainPAge(props) {
  return (
    <>
      <Navbar />
      <section className="immigration_main_section_container">
        <div className="section_immigration_under_container">
          <div className="section_header_for_immgration_contianer">
            <p className="title_text_immigration">IMMIGRATION</p>
            <p className="subtitle_text_immigration">
              Get your immigration process simplified by getting in touch with
              us. We at DWEC comprise comprises a very talented team of lawyers across
              the globe for your assistance.
            </p>
          </div>
        </div>
      </section>
      <div className="main_container_couselling_page_section">
        <section className="education gbg pb20" id="edu">
          <div className="left">
            <h2>Immigration/Visa Services</h2>

            <h3>Easy and hassle-free visa/immigration services by DWEC</h3>

            <p>
              Visa/Immigration process is very time taking and can sometimes
              become a hassle. But here, at DWEC we provide the assistance in
              India. We take care of visa applications of the students. A very
              dedicated team of lawyers works for us across the globe for
              immigration and visa services.
            </p>

            <p>
              You should apply for a visa once the student confirms his/her
              enrolment in the desired university/institution.
            </p>

            <h3>How to apply for visa?</h3>

            <p>
              This is a very popular question among students who wish to study
              abroad. But don't worry; we have got your back. So, here are the
              steps of the visa application process:
            </p>
          </div>

          <div className="clear"></div>
        </section>

        <section className="education gbg padding0">
          <div className="container">
            <div className="left width100">
              <ul>
                <li>
                  Once you have enrolled yourself in the desired university,
                  they will send you the visa documentation you need
                </li>

                <li>
                  Then you can apply for visa either through offline or online
                  mode.
                </li>

                <li>
                  The documents required when applying for a student visa include
                  passport and visa documents from your school. You may also
                  need other documents such as insurance, birth certificates,
                  certified grade reports, bank account statements, photos, etc.
                </li>

                <li>
                  Subsequently, you need to pay the visa fees required by almost
                  all the countries.
                </li>

                <li>
                  Visa application in most cases takes a couple of weeks to
                  process your application but most of the time it varies for
                  each person.
                </li>
              </ul>

              <p>&nbsp;</p>
            </div>
          </div>

          <div className="clear"></div>
        </section>

        <section className="edu-items bluebg">
          <div className="container">
            <h3 className="white" style={{ marginBottom: 20 }}>
              Documents Required for Student Visa Application
            </h3>

            <p className="white" style={{ marginBottom: 60 }}>
              Every country, depending on it’s Immigration Laws has a specific
              list of documents that may vary from country to country. However,
              below listed are a few documents that you would require to apply for
              a passport:
            </p>

            <div className="itms bord bo_op center_contianer_read_more_section">
              <figure>
                <div className="img_container_immigration">
                  <img src={immigration_img.default} alt="passport_img" />
                </div>
              </figure>

              <h4 className="white">Valid Passport</h4>

              <p className="white">
                This is the foremost requisite. While you would require a
                legitimate passport, the requirement of the validity of your
                passport might vary across different countries. Some countries
                would demand you to have the validity until the end of the
                course at the time of applying for the student visa. Some, on
                the contrary, might let you apply but appeal to you to have a
                validity that extends past the planned stay in the country.{" "}
              </p>
            </div>

            <div className="itms center_contianer_read_more_section">
              <figure>
                <div className="img_container_immigration">
                  <img src={immigration_img1.default} alt="passport_img" />
                </div>
              </figure>

              <h4 className="white">Letter of Acceptance</h4>

              <p className="white">
                Credit score plays a crucial role in determining your
                eligibility for loans, credit cards, etc. Timely payment of
                credit card bills & EMIs on existing loans reflects positively
                on your credit score and help in improving your chances of
                getting an education loan.
              </p>
            </div>

            <div className="clear"></div>

            <hr className="bo_op1" />

            <div className="itms bord bo_op center_contianer_read_more_section">
              <figure>
                <div className="img_container_immigration">
                  <img src={immigration_img3.default} alt="passport_img" />
                </div>
              </figure>

              <h4 className="white">Proof of Funds</h4>

              <p className="white">
                You are required to prove that you are capable of not only
                taking care of the tuition and college expenses but also having
                the essential funds to afford your stay in that country for the
                planned period of study. While most countries will demand
                a specific amount of funds required, some have broader and more
                comprehensive guidelines.
              </p>
            </div>

            <div className="itms center_contianer_read_more_section">
              <figure>
                <div className="img_container_immigration ">
                  <img src={immigration_img2.default} alt="passport_img" />
                </div>
              </figure>

              <h4 className="white">Language Proficiency</h4>

              <p className="white">
                Language proficiency is perhaps another requirement for applying
                for a student visa. Since most of the students choose 
                English-speaking countries as their study abroad destination, most of them
                would require you to provide proof of proficiency in the English
                language. For this purpose, you are required to undergo exams
                like TOEFL, IELTS, and/or PTE.
              </p>
            </div>

            <div className="clear"></div>
          </div>
        </section>

        <section className="edu-items">
          <div className="container">
            <h3 style={{ marginBottom: 20 }}>How we can help you?</h3>

            <p>
              We will help you in the entire visa application process. Our team
              of lawyers will keep you updated regarding the latest information
              or documents required for a visa. In order to reduce your
              inconvenience, we will handle everything and additionally, we can
              help you courier, and certify your documents.
            </p>

            <div className="clear"></div>
          </div>
        </section>
      </div>
      <InterestedSectionMain />
      <Footer />
    </>
  );
}

export default ImmigrationMainPAge;
